import { asPage } from 'src/components/hoc/asPage'
import { FeedbackPage } from 'src/compositions/Feedback'

export default asPage(FeedbackPage, { pageTitle: 'アポイント・評価' })
